const STORAGE_KEY = "tallocateMatchTarget";
const POOLS_KEY = "tallocateTalentPools";

export const normalizeSkill = (s) => String(s || "").trim().toLowerCase();

export const getMatchTarget = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { skills: [], minExperience: 0 };
    const parsed = JSON.parse(raw);
    return {
      skills: Array.isArray(parsed.skills) ? parsed.skills : [],
      minExperience: Number(parsed.minExperience) || 0,
    };
  } catch (e) {
    return { skills: [], minExperience: 0 };
  }
};

export const setMatchTarget = (target) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(target));
  } catch (e) {}
};

export const computeMatchScore = (candidateSkills, candidateExperience, target) => {
  const targetSkills = (target && target.skills) || [];
  if (targetSkills.length === 0) {
    return { score: null, matched: [], missing: [], experienceMet: true };
  }

  let skillArray = [];
  if (Array.isArray(candidateSkills)) {
    skillArray = candidateSkills;
  } else if (typeof candidateSkills === "string" && candidateSkills.length > 0) {
    skillArray = candidateSkills.split(/[;,]/);
  }
  const candSet = new Set(skillArray.map(normalizeSkill).filter(Boolean));
  const targetSet = targetSkills.map(normalizeSkill).filter(Boolean);

  const matched = [];
  const missing = [];
  targetSet.forEach((t) => {
    if (candSet.has(t)) matched.push(t);
    else missing.push(t);
  });

  const skillScore = targetSet.length === 0 ? 0 : matched.length / targetSet.length;

  const minExp = Number(target.minExperience) || 0;
  const exp = Number(candidateExperience) || 0;
  let expScore;
  let experienceMet = true;
  if (minExp <= 0) {
    expScore = 1;
  } else if (exp >= minExp) {
    expScore = 1;
  } else {
    expScore = exp / minExp;
    experienceMet = false;
  }

  const score = Math.round((skillScore * 0.8 + expScore * 0.2) * 100);
  return { score, matched, missing, experienceMet };
};

export const getTalentPools = () => {
  try {
    const raw = localStorage.getItem(POOLS_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

export const saveTalentPool = (name, query) => {
  if (!name || !name.trim()) return getTalentPools();
  const pools = getTalentPools();
  const cleanName = name.trim();
  const filtered = pools.filter((p) => p.name !== cleanName);
  const next = [
    { name: cleanName, query: query || "", savedAt: Date.now() },
    ...filtered,
  ].slice(0, 20);
  try {
    localStorage.setItem(POOLS_KEY, JSON.stringify(next));
  } catch (e) {}
  return next;
};

export const deleteTalentPool = (name) => {
  const pools = getTalentPools().filter((p) => p.name !== name);
  try {
    localStorage.setItem(POOLS_KEY, JSON.stringify(pools));
  } catch (e) {}
  return pools;
};
